class ProgressSpinner {

    element: JQuery

    constructor(element: JQuery) {
        this.element = element
    }

    show() {
        this.element.show()
    }

    hide() {
        this.element.hide()
    }
}

export default ProgressSpinner